import { useState } from "react";
import { Container, Title, Stack, Loader, Alert, Group } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { useAnalytics } from "./hooks";
import {
  PeriodFilter,
  AdoptionRateCard,
  DetailedMetricsChart,
} from "./components";
import type { AnalyticsPeriod } from "./types";

export const AnalyticsPage = () => {
  const [period, setPeriod] = useState<AnalyticsPeriod>("all");
  const { data, loading, error } = useAnalytics(period);

  if (loading) {
    return (
      <Container size="xl" py="xl">
        <Stack align="center" gap="xl">
          <Title order={1}>OneClick Analytics Dashboard</Title>
          <Loader size="lg" />
        </Stack>
      </Container>
    );
  }

  if (error) {
    return (
      <Container size="xl" py="xl">
        <Stack gap="xl">
          <Title order={1}>OneClick Analytics Dashboard</Title>
          <Alert
            icon={<IconAlertCircle size="1rem" />}
            title="Error Loading Analytics"
            color="red"
          >
            {error}
          </Alert>
        </Stack>
      </Container>
    );
  }

  if (!data) {
    return (
      <Container size="xl" py="xl">
        <Stack gap="xl">
          <Title order={1}>OneClick Analytics Dashboard</Title>
          <Alert color="yellow">No analytics data available</Alert>
        </Stack>
      </Container>
    );
  }

  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <Group justify="space-between" align="center">
          <Title order={1}>OneClick Analytics Dashboard</Title>
          <PeriodFilter period={period} onChange={setPeriod} />
        </Group>

        <AdoptionRateCard adoptionRate={data.adoptionRate} />

        <DetailedMetricsChart detailed={data.detailed} period={period} />
      </Stack>
    </Container>
  );
};
